import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import BookmarkDetailsOcr from './bookmark-details-ocr';
import RenderPolygonBasedStatementDetails from 'utils/ocr-statement-details-utils';
import { useLocation } from 'react-router-dom';
import { ROUTE_CONSTANTS } from 'constants/util/route-constants';
import { ELEMENT_SELECT_MODES } from 'constants/feature/modes-constants';
import { useDispatch } from 'react-redux';
import {
  toggleFormulaCancelModal,
  openSectionPanelAfterCancelConfirmAction,
  storeSelectedSectionIdAction,
  toggleInternalReferenceCancelModal,
} from 'store/actions/panel-cancel-modal-actions';
import { onSectionClick } from 'store/actions/statement-content-actions';

const BookmarksDetailsContainerOCR = ({
  bookmarksList,
  scale,
  dpi,
  leftSideView,
  sectionId,
}) => {
  const pathName = useLocation().pathname;
  const dispatch = useDispatch();
  const isSideBySideView = pathName.includes(ROUTE_CONSTANTS.SIDE_BY_SIDE);

  const {
    projectUsersList,
    sectionReview,
    sectionAssignments,
    leftSectionReview,
    displayElementDetailsOnStatementPage,
    selectedSectionsMap,
    selectModeId,
    selectedSection,
    section,
  } = useSelector((state) => {
    const isLeftSide = isSideBySideView && leftSideView;
    const sectionMap = isLeftSide
      ? state.data.leftStatementContent.leftSectionsCache.leftContentSectionMap
      : state.data.statementContent.sectionsCache.contentSectionMap;

    return {
      projectUsersList: state.data.projectUsersList,
      sectionReview: state.data.sectionPanel.sectionReviewList,
      sectionAssignments: state.data.sectionPanel.sectionAssignmentsList,
      leftSectionReview: state.data.leftStatementContent.leftSectionReviewsList,
      displayElementDetailsOnStatementPage:
        state.data.statementSummary.statementSummaryElementsDisplay
          .displayElementDetailsOnStatementPage,
      selectedSectionsMap: state.ui.statementPage.selectedSectionsMap,
      selectModeId: state.ui.statementPage.modes.selectMode.id,
      selectedSection: isLeftSide
        ? state.data.leftStatementContent.leftSelectedSection[sectionId]
        : state.ui.statementPage.selectedSectionsMap[sectionId],
      section:
        sectionMap?.map?.[sectionId] &&
        Object.values(sectionMap.map[sectionId]).find(
          (entry) => entry?.sectionId === sectionId,
        ),
    };
  }, shallowEqual);

  const handleElementClick = (sectionId, bookmarkId) => {
    if (isSideBySideView) {
      return () => {};
    } else {
      if (selectModeId === ELEMENT_SELECT_MODES.FORMULA.id) {
        dispatch(toggleFormulaCancelModal(true));
        dispatch(storeSelectedSectionIdAction(sectionId));
        dispatch(openSectionPanelAfterCancelConfirmAction(true));
      } else if (selectModeId === ELEMENT_SELECT_MODES.INTERNAL_REFERENCE.id) {
        dispatch(toggleInternalReferenceCancelModal(true));
        dispatch(storeSelectedSectionIdAction(sectionId));
        dispatch(openSectionPanelAfterCancelConfirmAction(true));
      } else {
        dispatch(
          onSectionClick({
            sectionId,
            sectionClick: true,
            bookmarkId,
          }),
        );
      }
    }
  };

  const pageBookmarks = [];

  bookmarksList &&
    !!bookmarksList.length &&
    bookmarksList.map((bookmark) => {
      if (!bookmark.deleted) {
        const { polygon } = bookmark;

        pageBookmarks.push(
          <RenderPolygonBasedStatementDetails
            coordinates={polygon}
            scale={scale * dpi}
            key={bookmark.id}
            loopCount={0} // loopcount is set to 0 to show icon for the first bookmark in case of multi-line bookmark scenario.
            displayIcon={true}
          >
            <BookmarkDetailsOcr
              bookmark={bookmark}
              leftSideView={leftSideView}
              isSideBySideView={isSideBySideView}
              shouldSectionAnchorDisabled={
                isSideBySideView ? !leftSideView : leftSideView
              }
              handleElementClick={handleElementClick}
              section={section}
              sectionId={sectionId}
              sectionReview={leftSideView ? leftSectionReview : sectionReview}
              sectionAssignments={sectionAssignments}
              color={
                selectedSectionsMap?.[sectionId]?.bookmarkId === bookmark.id
                  ? selectedSectionsMap?.[sectionId]?.color
                  : null
              }
              displayElementDetailsOnStatementPage={
                displayElementDetailsOnStatementPage
              }
              bookmarkId={bookmark.id}
              selectedSection={selectedSection}
              projectUsersList={projectUsersList}
            />
          </RenderPolygonBasedStatementDetails>,
        );
      }
    });

  return <>{pageBookmarks}</>;
};

export default BookmarksDetailsContainerOCR;
